import ServiceCRUD from '../../../services/ServiceCRUDNOTIFICATIONS';

class AllNotificationService extends ServiceCRUD {
  constructor() {
    super('/api/notifications');
  }
}

export default new AllNotificationService();
